<template>
	<div class="row justify-content-center">
		<div class="col-lg-3 col-md-6 text-center my-3">
			<div class="circle-loader">
				<i class="fa fa-spin fa-spinner"></i>
			</div>
			<h4>Repository</h4>
			<p class="font-courier mt-0">
				<span class="res-progress" title="Edit">?/?</span>
			</p>
		</div>
		<div class="col-lg-3 col-md-6 text-center my-3">
			<div class="circle-loader">
				<i class="fa fa-spin fa-spinner"></i>
			</div>
			<h4>Commit (2021)</h4>
			<p class="font-courier my-0"><span class="res-progress" title="Edit">?/?</span></p>
		</div>
		<div class="col-lg-3 col-md-6 text-center my-3">
			<div class="circle-loader">
				<i class="fa fa-spin fa-spinner"></i>
			</div>
			<h4>Star</h4>
			<p class="font-courier my-0"><span class="res-progress" title="Edit">?/?</span></p>
		</div>
		<div class="col-lg-3 col-md-6 text-center my-3">
			<div class="circle-loader">
				<i class="fa fa-spin fa-spinner"></i>
			</div>
			<h4>Fork</h4>
			<p class="font-courier my-0"><span class="res-progress" title="Edit">?/?</span></p>
		</div>
		<div class="col-lg-3 col-md-6 text-center my-3">
			<div class="circle-loader">
				<i class="fa fa-spin fa-spinner"></i>
			</div>
			<h4>Followers</h4>
			<p class="font-courier my-0"><span class="res-progress" title="Edit">?/?</span></p>
		</div>
		<div class="col-lg-3 col-md-6 text-center my-3">
			<div class="circle-loader">
				<i class="fa fa-spin fa-spinner"></i>
			</div>
			<h4>Pull Request</h4>
			<p class="font-courier my-0"><span class="res-progress" title="Edit">?/?</span></p>
		</div>
	</div>
</template>

<script>
export default {
	
}
</script>

<style>
	
</style>